/**
 * Hotel Config Selectors
 *
 * Selectors for common hotel configuration state.
 */
import type { RootState } from '@/store/store';

// ============================================
// Listing Search Context Selectors
// ============================================

/**
 * Select listing search context from listing API response.
 * Use this for:
 * - Listing page search widget
 * - Initial hotel details API call (from listing)
 */
export const selectListingSearchContext = (state: RootState) =>
  state.hotels.config.listingSearchContext;

// ============================================
// Details Search Context Selectors
// ============================================

/**
 * Select details search context from details API response.
 * Use this for:
 * - Details page search widget
 * - Room selection, booking review, and all subsequent actions
 */
export const selectDetailsSearchContext = (state: RootState) =>
  state.hotels.searchContext.detailsSearchContext;

// ============================================
// Currency Config Selectors
// ============================================

export const selectCurrencyConfig = (state: RootState) => state.hotels.config.currencyConfig;
